<section class="section-div">
  <div class="content-details">
    <form action="" [formGroup]="budget">
      <div>
        <table class="table">
          <thead
            style="
              padding: 18px;
              background-color: #0c0249;
              color: white;
              text-align: center;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            "
          >
            <tr>
              <th scope="col" style="width: 120px">S.No</th>
              <th scope="col">Expenditure Heads</th>
              <th scope="col">Total Amount (Rs in Lakhs) - 2 years</th>
            </tr>
          </thead>
          <tbody
            style="
              background-color: #fff;
              text-align: center;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            "
          >
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-center"><b>1.Non-Recurring</b></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">a</th>
              <td class="pt-4 text-left">
                Establishment of equipment relevant to thrust area and pilot
                facilities
              </td>
              <td>
                <div class="form-rows pt-4">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetEstablishmentEquipment"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">b</th>
              <td class="pt-4 text-left">
                Office equipment including computers, printers, and another
                communication network with installations
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetOfficeEquipment"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-right">Total(1)</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetNonRecurryingTotal"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-center"><b>2.Recurring - 2 Years</b></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">a</th>
              <td class="pt-4 text-center">
                <p class="mt-2">
                  Manpower (full-time dedicated team) (including support for
                  capacity building of team)
                </p>
              </td>
              <td></td>
            </tr>
            <tr>
              <td scope="row" class="pt-4"></td>
              <td class="pt-4 text-left">i.Vice President - One</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingvp"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="pt-4"></td>
              <td class="pt-4 text-left">
                ii.Project Lead (R2C & Incubation) - One
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingIncubationpl"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="pt-4"></td>
              <td class="pt-4 text-left">
                iii.Project Lead (Marketing & CSR) - One
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingMarketingpl"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <td scope="row" class="pt-4"></td>
              <td class="pt-4 text-left">iv.Project Associate - Three</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingProjectAssociate"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">b</th>
              <td class="pt-4 text-left">Utility and Maintenance</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingUtility"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">c</th>
              <td class="pt-4 text-left">
                Marketing, Promotion, and Publicity
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingMarketing"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">d</th>
              <td class="pt-4 text-left">Networking and Training Programmes</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingNetworking"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">e</th>
              <td class="pt-4 text-left">Administrative Overheads</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingAdministrativeOverhead"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">f</th>
              <td class="pt-4 text-left">
                Consumables including printing, books, etc
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingConsumables"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">g</th>
              <td class="pt-4 text-left">Miscellaneous</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetRecurryingMiscellaneous"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-right">Total (2)</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetRecurryingTotal"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-right">Total (1+2)</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetNonRecurryingAndRecurryingTotal"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center mt-3">
        <button
          mat-raised-button
          color="primary"
          (click)="saveBtn()"
          *ngIf="!showForm"
        >
          Save & Next
        </button>
      </div>
    </form>
  </div>
</section>
